import { useStore } from '../state/store';

/**
 * Pantallas que todavía no tienen datos reales: con “Mis visitas reales” se muestran como
 * Próximamente para que nadie confunda datos de ejemplo con los suyos.
 */
export function DemoGate({ title }: { title: string }) {
  const s = useStore();
  return (
    <div className="content">
      <section className="w" aria-label={title} style={{ alignItems: 'flex-start', padding: 28, gap: 10 }}>
        <span className="soon">Próximamente</span>
        <h2 style={{ margin: 0 }}>{title}</h2>
        <p className="muted" style={{ margin: 0 }}>Esta pantalla todavía no está conectada a tus datos. Puedes verla con datos de ejemplo.</p>
        <div className="row wrap">
          <button type="button" className="btn pri" onClick={() => { s.setAgendaMode('calendario'); s.go('agenda'); }}>Ir al calendario</button>
          <button type="button" className="btn" onClick={() => s.setDataSource('demo')}>Ver con datos de ejemplo</button>
        </div>
      </section>
    </div>
  );
}
